export default __webpack_public_path__ + "static/14-96ad849f43ef77462a1688c103374484.jpg";